import React, { useState, useEffect } from 'react';
import { Icon, Button, Spin, Checkbox } from 'antd';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { TransferWizard, BeneficiaryModal } from '../../Common';
import { ContactInfo } from './contact_info';
import { BeneficiariesInfo } from './beneficiaries_info';
import { Beneficiary } from '../../../models';
import { alertify, handleApiExceptions, generate_query_set } from '../../../app_methods';
import { FullWidthDivider, Text5 } from '../../../styles';
import './index.scss';
import { PermissionHoc } from '../../HOC';

const PermissableButton = PermissionHoc(Button,"BENEFICIARIES_WRITE", { is_component: true, fallbackComponent: null });

const BeneficiariesDrawer = (props) => {
    const [isListLoading, setIsListLoading] = useState(false);
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [beneficiary, setBeneficiary] = useState({});
    const [beneficiaryModal, setBeneficiaryModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [activeBeneficiary, setActiveBeneficiary] = useState({});
    const [transferRequestWizard, setTransferRequestWizard] = useState(false);


    const fetchBeneficiaries = async (showDeactivated = false) => {
        setIsListLoading(true);
        // let filterargs = { contact_id: props.contact.uuid, pageSize: 100, is_submerchant: props.contact.is_submerchant };
        let filterargs = { contact_id: props.contact.uuid, pageSize: 100 };
        filterargs = showDeactivated ? filterargs : { ...filterargs, is_active: true };
        const response = await Beneficiary.list_v2(filterargs);
        if (!response.success) {
            setIsListLoading(false);
            handleApiExceptions(response);
            return;
        }
        setBeneficiaries(generate_query_set(Beneficiary, response.data.results));
        setIsListLoading(false);
    };

    const saveBeneficiary = async (values) => {
        setIsSaving(true);
        const beneficiary = new Beneficiary(values);
        let response
        let message = "Beneficiary created successfully."
        if (values.id){
            response = await beneficiary.update();
            message = "Beneficiary updated successfully."
        } else {
            response = await beneficiary.save();
        }
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", message, "success");
        toggleBeneficiaryModal();
        setIsSaving(false);
        fetchBeneficiaries();
    };

    const updateStatus = async (values, is_active) => {
        setIsListLoading(true);
        const beneficiary = new Beneficiary(values);
        const response = await beneficiary.updateStatus({ active: is_active });
        if (!response.success) {
            setIsListLoading(false);
            handleApiExceptions(response);
            return;
        }
        setIsListLoading(false);
        fetchBeneficiaries();
    };

    const toggleBeneficiaryModal = (beneficiary = {}) => {
        setBeneficiaryModal(!beneficiaryModal);
        setBeneficiary(beneficiary)
    };

    const toggleTransferWizard = (beneficiary = {}) => {
        setActiveBeneficiary(beneficiary);
        setTransferRequestWizard(!transferRequestWizard);
    };

    const handleShowDeactivatedChange = (e) => {
        fetchBeneficiaries(e.target.checked);
    };

    const renderCreateButton = (type = "primary", size = "default") => {
        return (
            <PermissableButton size={size} type={type} onClick={toggleBeneficiaryModal}>
                <Icon type="plus" /> New Beneficiary
            </PermissableButton>
        )
    };

    const renderShowDeactivated = () => {
        return (
            <div>
                <Text5>Show Deactivated:</Text5>
                <Checkbox
                    className="ml-1"
                    size="small"
                    onChange={handleShowDeactivatedChange}
                />
            </div>
        )
    }

    return (
        <EaseDrawer
            className="beneficiaries-drawer-wrapper"
            visible={props.visible}
            hideHeader
            hideFooter
            destroyOnClose
            title={false}
            width={500}
            onOpen={() => fetchBeneficiaries()}
            onClose={() => { setBeneficiaries([]); props.toggleBeneficiariesDrawer() }}
        >
            <div>
                <ContactInfo contact={props.contact} />
                <FullWidthDivider />
                <div className="d-flex justify-content-between" style={{ padding: "15px", paddingBottom: 0 }}>
                    {renderShowDeactivated()}
                    {
                        // beneficiaries.length && !props.contact.is_submerchant?
                            beneficiaries.length ?
                            renderCreateButton("primary", "small") : null
                    }
                </div>
                <Spin spinning={isListLoading}>
                    <BeneficiariesInfo
                        beneficiaries={beneficiaries}
                        updateStatus={updateStatus}
                        toggleTransferWizard={toggleTransferWizard}
                        toggleBeneficiaryModal={toggleBeneficiaryModal}
                        // is_submerchant = {!props.contact.is_submerchant}
                    />
                    {
                        // !beneficiaries.length && !props.contact.is_submerchant ?
                        !beneficiaries.length ?
                            <div className="d-flex justify-content-center">
                                {renderCreateButton("dashed", "default")}
                            </div> : null
                    }
                </Spin>
                <BeneficiaryModal
                    visible={beneficiaryModal}
                    toggleBeneficiaryModal={toggleBeneficiaryModal}
                    contact={props.contact}
                    onSubmit={saveBeneficiary}
                    loading={isSaving}
                    beneficiary={beneficiary}
                />
                <TransferWizard
                    visible={transferRequestWizard}
                    toggleTransferWizard={toggleTransferWizard}
                    selectedContact={props.contact}
                    selectedBeneficiary={activeBeneficiary}
                />
            </div>
        </EaseDrawer>
    );
};

export { BeneficiariesDrawer };